import React from 'react';
import './skeleton.css';

interface SkeletonTableProps {
  columns: number;
  rows?: number;
  showHeader?: boolean;
}

const SkeletonTable: React.FC<SkeletonTableProps> = ({
  columns,
  rows = 5,
  showHeader = true
}) => {
  return (
    <div className="skeleton-table-container">
      <table className="skeleton-table">
        {showHeader && (
          <thead>
            <tr>
              {Array.from({ length: columns }).map((_, index) => (
                <th key={`header-${index}`}>
                  <div className="skeleton-table-cell skeleton-shimmer" />
                </th>
              ))}
            </tr>
          </thead>
        )}
        <tbody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <tr key={`row-${rowIndex}`}>
              {Array.from({ length: columns }).map((_, colIndex) => (
                <td key={`cell-${rowIndex}-${colIndex}`}>
                  <div className="skeleton-table-cell skeleton-shimmer" />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SkeletonTable;
